export class DomesticSalesModel{
    id: number;
    customer:number;
    varient: number;
    packStyleId: number;
    quantity: number;
    location: number;
    stockId: number;
    unitPrice: number;
    taxId: number;
    amount: number;
    cases: number;
    loosePouches: number;
    unitId: number;
    createdUser:string;
    updatedUser:string;
    isActive:boolean;
    locationName?: string; // will not be present during the request
    stockQnty?:number;
    stockLoosePouch?:number;
    domesticSaleOrderNo?: string;
    saleOrderDate?: Date;
    packStyle?:string;
    transactionType?:string;
    productCategory?:string
    
    constructor(   id: number,
        customer:number,
        varient: number,
        packStyleId: number,
        quantity: number,
        location: number,
        stockId: number,
        unitPrice: number,
        taxId: number,
        amount: number,
        cases: number,
        loosePouches: number,
        unitId: number,
        createdUser:string,
        updatedUser:string,
        isActive:boolean,
        locationName: string,
       stockQnty?:number,
       stockLoosePouch?:number,
       domesticSaleOrderNo?: string,
       saleOrderDate?: Date,
       packStyle?:string,
       transactionType?:string,
       productCategory?:string

    ){
        this.id = id;
        this.customer = customer;
        this.varient=varient;
        this.packStyleId=packStyleId;
        this.quantity = quantity;
        this.location = location;
        this.stockId=stockId;
        this.unitPrice=unitPrice;
        this.taxId = taxId;
        this.amount = amount;
        this.cases=cases;
        this.loosePouches=loosePouches;
        this.unitId=unitId;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.isActive = isActive;
        this.locationName = locationName;
        this.stockQnty = stockQnty
        this.stockLoosePouch = stockLoosePouch
        this.domesticSaleOrderNo = domesticSaleOrderNo
        this.saleOrderDate = saleOrderDate
        this.packStyle=packStyle
        this.transactionType=transactionType
        this.productCategory=productCategory
    }
}